import { AppState } from '@store/app.store';
import { createSelector } from '@ngrx/store';
import { sessionAdapter } from '@store/reducer/session.reducer';

export const selectFeatureSession = (state: AppState) => state.session;

export const selectIsLoadingSession = createSelector(
  selectFeatureSession,
  state => state.isLoading
);

export const selectSession = createSelector(
  selectFeatureSession,
  sessionAdapter.getSelectors().selectAll
);

export const selectSessionError = createSelector(
  selectFeatureSession,
  state => state.error
);
